import { Badge } from "@/shared/ui/badge";
import type { Progress } from "../types";

export function ScoreHeader({ progress }: { progress: Progress | undefined }) {
  return (
    <div className="flex items-center gap-2">
      <Badge variant="secondary">🔥 Streak {progress?.current_streak ?? 0}</Badge>
      <Badge variant="secondary">⭐ {progress?.points ?? 0} pts</Badge>
      <Badge variant="secondary">🏷 {progress?.labels_count ?? 0} labeled</Badge>
    </div>
  );
}
